import { secondsToMilliseconds } from 'date-fns';
import { defaultTo, isDate, isNil, min } from 'lodash-es';
import type { TokenPayload } from './authentication-tokens';

export const getExpirationDate = (token: TokenPayload | null) => {
  if (isNil(token?.exp)) {
    return null;
  }
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return new Date(secondsToMilliseconds(token!.exp));
};

export const getEarliestExpirationDate = (tokens: (TokenPayload | null)[]) => {
  const expirationDate = min(
    tokens
      .map(token => getExpirationDate(token))
      .filter(isDate),
  );

  return defaultTo(expirationDate, new Date());
};
